import {Directive} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators} from "@angular/forms";
import {FieldValidationMessage} from "../field/field-validation-message";

@Directive({
    selector: "[woa-email]",
    providers: [{provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true}]
})
export class EmailDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        const errors: {
            [key: string]: any
        } = Validators.pattern("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}")(control);
        return errors ? Object.keys(errors).map((key: string) => new FieldValidationMessage(key, "woa.validation.common.invalidEmail")) : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/email-field/email.directive.ts